import React from 'react';
import Footer from "../layouts/Footer"

const Success = () => {

    return (
        <div style={{ height: '80vh', padding: '5em' }}>
            <h1>Success</h1>
            <h3>Payment Processed successfully</h3>
            <Footer />
        </div>
    );
};

export default Success;
